import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GeneratedReport,
  GenerationJob,
  ReportAccount,
  ReportDescriptionResponse,
} from '../reports/models/report';

type ReportsState = {
  reportGenerationJobResult?: GenerationJob;
  reportResults?: GeneratedReport[];
  reportAccounts?: ReportAccount[];
  reportDescription?: ReportDescriptionResponse;
  error: string;
};

const initialState: ReportsState = {
  reportResults: undefined,
  error: '',
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    generateReportsSuccess: (state, action: PayloadAction<GeneratedReport[]>) => {
      state.reportResults = action.payload;
    },
    generateReportsAsyncSuccess: (state, action: PayloadAction<GenerationJob>) => {
      state.reportGenerationJobResult = action.payload;
    },
    fetchReportsDescriptionSuccess: (state, action: PayloadAction<ReportDescriptionResponse>) => {
      state.reportDescription = action.payload;
    },
    fetchReportAccountsSuccess: (state, action: PayloadAction<ReportAccount[]>) => {
      state.reportAccounts = action.payload;
    },
    resetReportAccounts: (state) => {
      state.reportAccounts = undefined;
    },
  },
});

export const {
  resetReportAccounts,
  generateReportsSuccess,
  fetchReportAccountsSuccess,
  fetchReportsDescriptionSuccess,
} = reportsSlice.actions;
